import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { ChartAdapter } from './chart.adapter';
import { ChartActionPopupComponent } from './components/chart-action-popup/chart-action-popup.component';
import { ChartListComponent } from './components/chart-list/chart-list.component';
import {
	ChartEffects,
	ChartFeatureKey,
	chartReducers,
	ChartSelector,
} from './store';

@NgModule({
	declarations: [ChartListComponent, ChartActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		FormsModule,
		StoreModule.forFeature(ChartFeatureKey, chartReducers),
		EffectsModule.forFeature([ChartEffects]),
		DxDataGridModule,
		NgOptimizedImage,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcAvatarModule,
		DcBadgeModule,
		DcBreadcrumbModule,
		DcOverlayBadgeModule,
		DcPopoverModule,
		DcButtonModule,
	],
	providers: [ChartAdapter, ChartSelector],
})
export class ChartModule {
	public constructor(private readonly injector: Injector) {
		const chartListCmpElement = createCustomElement(ChartListComponent, {
			injector,
		});
		customElements.define('app-chart-list', chartListCmpElement);
	}
}
